import { localize } from "locale"

export default {
  required: localize("fieldRequired"),
}
